<template>
  <div class="users">
    <!-- HEADER WITH SWITCH AND NEW USER BUTTON -->
    <div class="users-header">
      <h2 class="desktop">Потребители</h2>
      <!-- ACTIVE/INACTIVE SWITCH -->
      <div class="switch-wrapper">
        <label
          class="switch-label"
          :class="{ 'switch-label-active': !showActiveUsers }"
          @click="showActiveUsers = false"
        >Неактивни</label>
        <div class="switch-container">
          <label class="switch">
            <input type="checkbox" v-model="showActiveUsers" />
            <span class="slider"></span>
          </label>
        </div>
        <label
          class="switch-label"
          :class="{ 'switch-label-active': showActiveUsers }"
          @click="showActiveUsers = true"
        >Активни</label>
      </div>
      <div class="btns desktop">
        <!-- OTPUSKS BUTTON -->
        <router-link
          to="/otpusks"
          class="btn btn-otpusks"
          v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
        >
          <span class="miv2">j</span>
          Справка отпуски
        </router-link>
        <!-- NEW USER BUTTON -->
        <button
          class="btn btn-new"
          @click="isUserModalOpened = true"
          v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
        >
          <span class="miv">V</span>
          Нов потребител
        </button>
      </div>
    </div>
    <!-- DESKTOP TABLE WITH USERS (ACTIVE AND INACTIVE) -->
    <div class="table-wrapper desktop">
      <table class="table">
        <tbody>
          <tr
            v-for="user of searchFilter()"
            :key="user._id"
            :class="{ 'inactive-row': !showActiveUsers}"
            @click="editUser(user)"
          >
            <td class="td-user-name">
              <span class="miv">B</span>
              <span>
                <strong>{{user.name}}</strong>
              </span>
            </td>
            <td>{{user.username}}</td>
            <td>{{user.email}}</td>
            <td>{{user.phone}}</td>
            <td>
              <span
                v-if="user.permissions.isSuperAdmin"
                class="permission-indicator superadmin-indicator"
              >J</span>
              <span
                v-if="user.permissions.isAdmin"
                class="permission-indicator admin-indicator"
              >Администратор</span>
              <span v-if="user.permissions.isHR" class="permission-indicator hr-indicator">ЧР</span>
              <span
                v-if="user.permissions.isReporter"
                class="permission-indicator reporter-indicator"
              >Отчетник</span>
              <span
                v-if="user.permissions.isWorker"
                class="permission-indicator worker-indicator"
              >Работник</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- MOBILE TABLE WITH USERS (ACTIVE AND INACTIVE) -->
    <div class="table-wrapper mobile">
      <table class="table">
        <tbody>
          <tr
            v-for="user of searchFilter()"
            :key="user._id"
            :class="{ 'inactive-row': !showActiveUsers}"
            @click="editUser(user)"
          >
            <td class="td-user-name">
              <div class="user-mobile">
                <span>
                  <strong>{{user.name}}</strong>
                </span>
              </div>
              <div class="user-permissions">
                <span
                  v-if="user.permissions.isSuperAdmin"
                  class="permission-indicator superadmin-indicator"
                >J</span>
                <span
                  v-if="user.permissions.isAdmin"
                  class="permission-indicator admin-indicator"
                >Администратор</span>
                <span v-if="user.permissions.isHR" class="permission-indicator worker-indicator">ЧР</span>
                <span
                  v-if="user.permissions.isReporter"
                  class="permission-indicator reporter-indicator"
                >Отчетник</span>
                <span
                  v-if="user.permissions.isWorker"
                  class="permission-indicator worker-indicator"
                >Работник</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- BUTTON NEW USER FOR MOBILE -->
    <footer class="modal-footer mobile">
      <div
        class="new-content-data-item-toggle-circle mobile"
        @click="isUserModalOpened = true"
        v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
      >
        <span class="miv">V</span>
      </div>
      <router-link to="/otpusks" class="new-content-data-item-toggle-circle mobile otpusks">
        <span class="miv2">j</span>
      </router-link>
    </footer>
    <!-- USER MODAL -->
    <transition name="fade">
      <appUserModal v-if="isUserModalOpened" :idToEdit="idToEdit" />
    </transition>
  </div>
</template>

<script>
import UserModal from './shared/UserModal';
import { mapGetters } from 'vuex';
export default {
  components: {
    appUserModal: UserModal
  },
  data() {
    return {
      showActiveUsers: true,
      isUserModalOpened: false,
      idToEdit: '',
      users: [],
      search: ''
    };
  },
  computed: {
    ...mapGetters(['getUser']),
    // Filtered by active
    filteredUsers() {
      return this.users.filter(u => {
        return u.isActive === this.showActiveUsers;
      });
    }
  },
  methods: {
    // Filter users for searching by name
    searchFilter() {
      let filteredusers = this.filteredUsers;
      return filteredusers.filter(u => {
        return (
          u.name.toLowerCase().includes(this.search.toLowerCase()) ||
          u.username.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
    editUser(u) {
      if (
        !this.getUser.permissions.isSuperAdmin &&
        !this.getUser.permissions.isAdmin
      ) {
        this.$snotify.error('Нямате права да редактирате акаунти.');
        return;
      }
      this.idToEdit = u._id;
      this.isUserModalOpened = true;
    },
    getUsers() {
      this.$store.dispatch('startLoading');
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users`)
        .then(response => {
          this.users = response.data;
          this.$store.dispatch('stopLoading');
        });
    }
  },
  mounted() {
    this.getUsers();

    this.$on('closeUserModal', result => {
      this.isUserModalOpened = false;
      this.idToEdit = '';
      // if result.isEdited = true, this means something is changed and we get the users again
      if (result.isEdited) {
        this.users = [];
        this.getUsers();
      }
    });
  },
  updated() {
    // Handle search input
    this.$root.$on('sendSearchInput', data => {
      this.search = data;
      // console.log(this.search);
    });
  },
  destroyed() {
    this.$off('closeUserModal');
    this.$root.$off('sendSearchInput');
  }
};
</script>

<style scoped>
.users {
  padding: 10px 40px;
}
.users-header {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
}
.switch-wrapper {
  align-items: center;
  display: flex;
}
.switch {
  margin: 0 10px;
}
.switch-label {
  cursor: pointer;
  font-weight: 700;
  opacity: 0.4;
}
.switch-label-active {
  opacity: 1;
}
td {
  width: 20%;
}
.table tr td:last-child {
  white-space: nowrap;
}
.td-user-name span {
  vertical-align: middle;
}
.td-user-name .miv {
  margin: 0 7px 0 4px;
}
.inactive-row {
  background-color: #fff8f8;
}
.inactive-row:hover {
  background-color: #fbf0f0;
}
.desktop {
  display: flex;
}
.mobile {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
  }
  .users {
    padding: 10px 15px;
  }
  .users-header {
    justify-content: center;
  }
  .table-wrapper {
    overflow: auto;
  }
  .user-mobile {
    display: flex;
    justify-content: center;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }
  .user-permissions {
    display: flex;
    justify-content: center;
    padding-bottom: 0.5em;
  }
  .new-content-data-item-toggle-circle {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.otpusks {
    background-color: #217346;
    bottom: 80px;
  }
  .new-content-data-item-toggle-circle.otpusks .miv2 {
    border: 1px solid #217346;
  }
  .modal-footer {
    background-color: #f0f0f7;
    height: 75px;
    padding: 0px;
  }
}
</style>
